import React from 'react';
import { Icon } from '../icon'
import {
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/core";
import { pxToRem } from '../../../utils/dimensionConverter';

export const ModalBox = ({ onButtonClose, children, hideClose, insideScroll, minWidth, className }) => {
  return (
    <>
      <ModalOverlay/>
        <ModalContent className='modal' style={{minWidth: minWidth}}>
        <div className={`modal-content ${insideScroll ? 'modal-content--vertical-scroll' : ''} ${className}`}>
        { !hideClose && (
            <button className='modal-content__close' onClick={onButtonClose} data-testid="modal-close-btn">
              <Icon name='close' size={pxToRem(9)}/>
            </button>
          )}
          { children }
        </div>
      </ModalContent>
    </>
  );
};

export default ModalBox;